import React, { useEffect } from 'react'
import { useQueryParams } from '@fs/zion-router'
import { H3 } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { useDSCDispatch, ACTIONS } from '../state/DSCStore'
import CAFGuestUpload from '../caf2/components/CAFGuestUpload'

export const isValidShortcode = (code) => code?.match(/^[A-Za-z0-9]{4}-[A-Za-z0-9]{3}$/) // 4 alphanumeric, hyphen, 3 alphanumeric

export default function Shortcode() {
  const dscDispatch = useDSCDispatch()
  const { query } = useQueryParams()
  const { shortcode } = query
  const [t] = useTranslation()

  useEffect(() => {
    if (isValidShortcode(shortcode)) {
      dscDispatch({
        type: ACTIONS.SET_HEADER_FOOTER,
        data: {
          showHeader: false,
          showFooter: false,
        },
      })
    }
  }, [dscDispatch, shortcode])

  return (
    <>
      {isValidShortcode(shortcode) && <CAFGuestUpload />}
      {!shortcode && (
        <div css={{ padding: '100px' }}>
          <H3 centered>{t('longpoll.nocode', 'No shortcode found')}</H3>
        </div>
      )}
    </>
  )
}
